import { createFileRoute } from "@tanstack/react-router";
import { SideNavLayout } from "@/components/layouts/side-nav-layout";
import { NotFoundErrorPage } from "@/lib/error-boundary";
import { PlatformGuard } from "@/components/platform-guard";

export const Route = createFileRoute("/_authenticated/admin")({
	component: Admin,
	notFoundComponent: NotFoundErrorPage,
});

function Admin() {
	return (
		<PlatformGuard>
			<SideNavLayout platform="admin" />
		</PlatformGuard>
	);
}
